<template>
<div>
  <Grid name="userQueriesGrid" ref="userQueriesGrid" v-bind:url="url" v-bind:columns="columns" :pageable='true' :height="height" :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"></Grid>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import kendo from '@progress/kendo-ui/js/kendo.all.js'
export default {
  name: 'Client',
  props: ['height'],
  components: {
    Grid
  },
  data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'queries/sellin',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'carregar',
          click: this.loadQuery
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'apagar',
          click: this.deleteQuery
        }
      }, {
        field: 'name',
        title: 'Name'
      }],
      loaded: false,
      tableInitialized: false,
      variables: [],
      rows: [],
      subrows: [],
      filters: [],
      tables: []
    }
  },
  methods: {
    loadQuery(e) {
      e.preventDefault()
      var grid = this.$refs.userQueriesGrid.$refs.mygrid.kendoWidget()
      var dataItem = grid.dataItem(kendo.jQuery(e.currentTarget).closest('tr'))
      this.$emit('load-query', {
        item: dataItem
      })
    },
    deleteQuery(e) {
      e.preventDefault()
      var grid = this.$refs.userQueriesGrid.$refs.mygrid.kendoWidget()
      var dataItem = grid.dataItem(kendo.jQuery(e.currentTarget).closest('tr'))
      this.axios.delete('queries/' + dataItem.id).then(response => {
        grid.dataSource.read()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// UserQueries.vue?a6ae50ac